export const GET_WORKING_CAPITAL_STATEMENTS = 'GET_WORKING_CAPITAL_STATEMENTS';
export const GET_WORKING_CAPITAL_STATEMENT_DETAIL = 'GET_WORKING_CAPITAL_STATEMENT_DETAIL';
export const WORKING_CAPITAL_REPAYMENT = 'WORKING_CAPITAL_REPAYMENT'; 